class FormulaireFiltre {

  constructor(){
    this.formulaireChamp = document.querySelector('#js--formulaire-filtre');
    this.formulaireForm = document.querySelector('#js--formulaire-filtre--form');
    this._init();
  }

  _init(){
    document.addEventListener('DOMContentLoaded', (event) => {
      if( this.formulaireChamp ){
        this.formulaireChamp.addEventListener('change', 
          this._submitFormulaire.bind(this),
          false
        );            
      }  
    });
  }

  _submitFormulaire(){
    this.formulaireForm.submit();
  }
}

export const formulaireFiltre = new FormulaireFiltre();